import { Box } from '@mantine/core';
import { PaymentStatusResult } from '@bariendo/lib/payment-status';
import { PanelRow } from './PanelRow';
import { PaymentRow } from './PaymentRow';
import { BillingRow } from './services/billing';

interface BillingGroupProps {
  /** The stored payment status; absent off a payment path and for a viewer outside the payments roles. */
  paymentStatus?: PaymentStatusResult;
  rows: BillingRow[];
}

/**
 * "What do they owe" — rendered under a hairline that separates it from the
 * intake group, so the two questions read as two answers rather than one list.
 *
 * Renders nothing at all when there is nothing to say. Most patients are on no
 * payment path yet, and a present-but-empty group makes every early-funnel
 * patient look like a data fault.
 */
export function BillingGroup({ paymentStatus, rows }: BillingGroupProps) {
  if (!paymentStatus && rows.length === 0) return null;

  return (
    <>
      <Box style={{ height: 1, background: 'rgba(0, 0, 0, 0.06)', margin: '4px 0' }} />
      {paymentStatus && <PaymentRow status={paymentStatus} />}
      {rows.map((row, index) => (
        // Several rows can share a label (two Stripe payments), so the position keys them.
        <PanelRow key={`${index}-${row.label}`} label={row.label} value={row.value} />
      ))}
    </>
  );
}
